// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"4d1eb940","455":"aeb333ed","977":"8d83bd14"}[chunkId] + ".chunk.js";
};